import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
/**
 * フォームの情報
 */
const staffInfoHeadTitleList: any[] = [
  {
    headTitle: "職員氏名",
    helpText: (
      <>
        加入する職員の氏名です。
        <br />
        外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない恐れがありますので、当該文字は使用せず、常用漢字を用いて入力をお願いします。
        <br />
        なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
      </>
    ),
  },
  {
    headTitle: "生年月日",
    helpText: `加入する職員の生年月日を選択してください。`,
  },
  {
    headTitle: "性別",
  },
  {
    headTitle: "加入資格",
    helpText: (
      <>
        加入する職員の加入資格です。
        <br />
        加入資格ア：雇用期間に定めのない職員（いわゆる正規職員）
        <br />
        加入資格イ：週の労働時間（実働時間時間ではなく、雇用契約書で定められた時間）が就業規則で定める正規職員の週の所定労働時間の３分の２以上で、１年以上の雇用期間を定めて使用される職員
        <br />
        加入資格ウ：週の労働時間（実働時間時間ではなく、雇用契約書で定められた時間）が就業規則で定める正規職員の週の所定労働時間の３分の２以上で、１年未満の雇用期間を定めて使用され、その期間の更新により引き続き1年経過した職員
        <br />
        加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。`
      </>
    ),
  },
  {
    headTitle: "俸給額",
    helpText: (
      <>
        共済契約者が給与規程で定める本俸月額です。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。詳しくは、{" "}
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。<br></br>
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載してください。
      </>
    ),
  },
  {
    headTitle: "俸給の調整額",
    helpText: (
      <>
        俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。俸給の調整額として申請する手当がある場合は、契約申込書を提出後に改めて申請を行ってください。
      </>
    ),
  },
  {
    headTitle: "職員の更新",
    helpText: `登録した職員の情報を修正又は削除する場合は、それぞれボタンを押してください。`,
  },
  {
    headTitle: "雇用契約書の写し",
    helpText: `加入資格がイまたはウの職員については、契約希望日時点の雇用契約書を添付してください。`,
  },
];

const stepperData = [
  "法人情報",
  "施設情報・職員情報",
  "届出内容確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorname",
    type: "text",
  },
];

export { staffInfoHeadTitleList, fakeTableList, stepperData };
